import React from 'react';
import { useBootstrapSelector } from '../../redux/selectorHooks';
import { assertNotNil } from '../../utils/types';
import { IRowMeta } from '../../redux/slices/oldBuilder';
import SaveCohortEntityHeader from './SaveCohortEntityHeader';
import * as SaveEntityHeaderUI from './SaveEntityHeaderUI';
import { useAppSelector } from '../../redux/hooks';
import { activeSchemaIdSelector } from '../../redux/selectors/builder';
import * as BuilderUI from '../Builder/BuilderUI';

export enum SaveEntityHeaderEnum {
  NamedCohort,
  NamedMeasure,
  VirtualEvent,
  NamedFilter,
}

interface IProps {
  rowMeta?: IRowMeta;
  entityType: SaveEntityHeaderEnum;
}

export default ({ rowMeta, entityType }: IProps) => {
  const schemaConfig = useBootstrapSelector('schemaConfig');
  assertNotNil(schemaConfig);
  const { schemas } = schemaConfig;
  const activeSchemaId = useAppSelector(activeSchemaIdSelector);
  const schema = schemas.find(({ id }) => id === activeSchemaId)?.name;

  return (
    <SaveEntityHeaderUI.Container>
      <BuilderUI.BuilderFieldContainer>
        <BuilderUI.BuilderFieldLabel>Schema</BuilderUI.BuilderFieldLabel>
        <SaveEntityHeaderUI.Value>{schema}</SaveEntityHeaderUI.Value>
      </BuilderUI.BuilderFieldContainer>
      {entityType === SaveEntityHeaderEnum.NamedCohort && rowMeta && (
        <SaveCohortEntityHeader rowMeta={rowMeta} />
      )}
    </SaveEntityHeaderUI.Container>
  );
};
